import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("dcs_cart") || "[]"); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("dcs_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.product_id === product.id);
      if (found) {
        return prev.map((i) =>
          i.product_id === product.id ? { ...i, quantity: i.quantity + qty } : i);
      }
      return [...prev, {
        product_id: product.id, title: product.title, price: product.price,
        image: product.image, brand: product.brand, quantity: qty,
      }];
    });
  };

  const updateQty = (pid, qty) =>
    setItems((prev) => prev.map((i) => (i.product_id === pid ? { ...i, quantity: Math.max(1, qty) } : i)));
  const removeItem = (pid) => setItems((prev) => prev.filter((i) => i.product_id !== pid));
  const clear = () => setItems([]);

  const count = items.reduce((a, i) => a + i.quantity, 0);
  const subtotal = items.reduce((a, i) => a + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
};
